var addressObjList = "";
var map = "";
var cityCount = {};
var maxCity = "";
var maxCount = 0;
var markers = [];
var websiteURL = "";
var httpsWebSiteLink = "";
var infoWindow_old = new google.maps.InfoWindow();
var currentLatitude = "";
var currentLongitude = "";
document.addEventListener("DOMContentLoaded", function (event) {
  // Fetch data from the API and display it
  var addresList = "";
  var categoryList = "";
  var storeList = "";
  var selectElementAddress = $("#address-filter");
  var selectElementCategorie = $("#categorie-filter");
  var selectElementStore = $("#store-filter");

  initMap();
  //geocodeAddress();
  //https://shoping-card-backend.vercel.app/api/v1/spreedsheet/get
  const data = {};
  // fetch("https://shoping-card-backend.vercel.app/api/v1/spreedsheet/get", {
  //   method: "POST",
  //   body: JSON.stringify(data), // Convert data to JSON string
  //   headers: {
  //     "Content-Type": "application/json", // Specify content type
  //   },
  // })
  const datepagemetafield = document.querySelector(".filter-container").getAttribute("date-field");
  // shop name must be production store
  fetch(`https://hsc2025-ae359a5d503c.herokuapp.com/api/retailer-shops?shop=b3bcd9.myshopify.com&dataType=map-locator&since=${datepagemetafield}`)
    .then((response) => response.json())
    .then((data) => {
      console.log(data.finalArray);
      addressObjList = data.finalArray;
      displayData(data.finalArray);
      const filteredAddressesList = data.finalArray.filter(
        (item) =>
          item.location !== undefined &&
          item.location !== null &&
          item.location !== ""
      );
      // addresList = [
      //   ...new Set(
      //     filteredAddressesList.map((item) => item.location.toLowerCase())
      //   ),
      // ].sort();

      addresList = Array.from(
        new Map(
          filteredAddressesList.map((item) => [
            item.location.toLowerCase(),
            item.location,
          ])
        ).values()
      ).sort();

      const filterCategoryList = data.finalArray.filter(
        (item) =>
          item.category !== undefined &&
          item.category !== null &&
          item.category !== ""
      );
      // categoryList = [
      //   ...new Set(
      //     filterCategoryList.map((item) => item.category.toLowerCase())
      //   ),
      // ].sort();
      categoryList = Array.from(
        new Map(
          filterCategoryList.map((item) => [
            item.category.toLowerCase(),
            item.category,
          ])
        ).values()
      ).sort();

      const filterStoreList = data.finalArray.filter(
        (item) =>
          item.store_name !== undefined &&
          item.store_name !== null &&
          item.store_name !== ""
      );
      // storeList = [
      //   ...new Set(
      //     filterCategoryList.map((item) => item.store_name.toLowerCase())
      //   ),
      // ].sort();
      storeList = Array.from(
        new Map(
          filterCategoryList.map((item) => [
            item.store_name.toLowerCase(),
            item.store_name,
          ])
        ).values()
      ).sort();
    })
    .then((data) => {
      addresList.forEach(function (params) {
        var option = new Option(params, params);
        selectElementAddress.append(option);
      });
      var option = new Option("Online", "Online");
      selectElementCategorie.append(option);
      // option = new Option("Height", "Height");
      // selectElementCategorie.append(option);

      categoryList.forEach(function (params) {
        var option = new Option(params, params);
        selectElementCategorie.append(option);
      });

      storeList.forEach(function (params) {
        var option = new Option(params, params);
        selectElementStore.append(option);
      });

      selectElementAddress.select2({
        placeholder: "Select an address",
        allowClear: true,
      });
      selectElementCategorie.select2({
        placeholder: "Select a category",
        allowClear: true,
      });
      selectElementStore.select2({
        placeholder: "Select a store",
        allowClear: true,
      });

      for (let city in cityCount) {
        if (cityCount[city] > maxCount) {
          maxCount = cityCount[city];
          maxCity = city;
        }
      }
      var geocoder = new google.maps.Geocoder();
      // var address = "1600 Amphitheatre Parkway, Mountain View, CA"; // Replace with your address

      geocoder.geocode({ address: maxCity }, function (results, status) {
        if (status === "OK") {
          map.setCenter(results[0].geometry.location);
        }
      });
    })
    .catch((error) => {
      displayData(addressObjList);
    });
});

function getTopRetailerBadge(is_top_retailer) {
  if (is_top_retailer === true || is_top_retailer === "true") {
    return `<span class="top-retailer-badge">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="30px" width="30px" version="1.1" id="Capa_1" viewBox="0 0 14.064 14.064" xml:space="preserve"><g><g><path d="M11.465 5.719c0.275 -0.244 0.587 -0.521 0.587 -0.909s-0.312 -0.665 -0.587 -0.909c-0.156 -0.138 -0.332 -0.295 -0.37 -0.411 -0.041 -0.127 0.01 -0.367 0.056 -0.577 0.076 -0.352 0.163 -0.752 -0.057 -1.054 -0.222 -0.305 -0.631 -0.346 -0.992 -0.382 -0.213 -0.021 -0.454 -0.046 -0.56 -0.122 -0.103 -0.075 -0.199 -0.295 -0.283 -0.488 -0.146 -0.335 -0.312 -0.715 -0.675 -0.832A0.66 0.66 0 0 0 8.372 0c-0.277 0 -0.541 0.154 -0.797 0.303 -0.19 0.11 -0.404 0.235 -0.543 0.235 -0.14 0 -0.354 -0.125 -0.544 -0.235C6.233 0.154 5.969 0 5.692 0q-0.11 0 -0.212 0.033c-0.363 0.118 -0.529 0.497 -0.675 0.832 -0.085 0.194 -0.181 0.414 -0.283 0.488 -0.106 0.077 -0.347 0.101 -0.56 0.122 -0.361 0.036 -0.77 0.077 -0.992 0.382 -0.22 0.302 -0.133 0.701 -0.057 1.054 0.046 0.211 0.097 0.45 0.056 0.577 -0.038 0.116 -0.214 0.273 -0.37 0.411 -0.275 0.244 -0.588 0.521 -0.588 0.909s0.312 0.665 0.588 0.909c0.156 0.138 0.332 0.295 0.37 0.411 0.041 0.128 -0.01 0.367 -0.056 0.578 -0.076 0.352 -0.163 0.752 0.057 1.054 0.221 0.305 0.63 0.346 0.991 0.382l-1.461 4.709a0.281 0.281 0 0 0 0.382 0.341l1.512 -0.662 0.871 1.402a0.281 0.281 0 0 0 0.508 -0.065l1.26 -4.06 1.26 4.06a0.281 0.281 0 0 0 0.508 0.065l0.871 -1.402 1.512 0.662a0.282 0.282 0 0 0 0.3 -0.048 0.282 0.282 0 0 0 0.081 -0.293l-1.461 -4.708c0.361 -0.036 0.769 -0.077 0.991 -0.382 0.22 -0.302 0.133 -0.701 0.057 -1.054 -0.046 -0.211 -0.098 -0.45 -0.056 -0.577 0.038 -0.116 0.214 -0.273 0.37 -0.411M5.417 13.112l-0.675 -1.086a0.282 0.282 0 0 0 -0.352 -0.109l-1.171 0.513 1.294 -4.17 0.008 0.005c0.103 0.075 0.199 0.295 0.283 0.488 0.146 0.335 0.312 0.714 0.675 0.832q0.101 0.033 0.212 0.033c0.277 0 0.541 -0.154 0.797 -0.303l0.13 -0.074zm4.256 -1.195a0.282 0.282 0 0 0 -0.352 0.109l-0.675 1.086 -1.201 -3.871 0.13 0.074c0.256 0.149 0.52 0.303 0.797 0.303q0.11 0 0.212 -0.033c0.363 -0.118 0.529 -0.497 0.675 -0.832 0.085 -0.194 0.181 -0.414 0.283 -0.488l0.008 -0.005 1.294 4.17zm0.887 -5.961c-0.088 0.272 -0.022 0.576 0.041 0.87 0.049 0.226 0.11 0.506 0.038 0.604 -0.074 0.101 -0.362 0.13 -0.593 0.153 -0.298 0.03 -0.606 0.061 -0.835 0.227 -0.226 0.164 -0.349 0.446 -0.468 0.718 -0.094 0.215 -0.211 0.482 -0.334 0.523a0.12 0.12 0 0 1 -0.038 0.005c-0.125 0 -0.332 -0.12 -0.514 -0.226 -0.263 -0.154 -0.535 -0.312 -0.827 -0.312s-0.563 0.158 -0.827 0.312c-0.182 0.106 -0.388 0.226 -0.514 0.226a0.12 0.12 0 0 1 -0.038 -0.005c-0.122 -0.04 -0.239 -0.307 -0.334 -0.523 -0.119 -0.272 -0.242 -0.554 -0.468 -0.718 -0.229 -0.167 -0.537 -0.197 -0.835 -0.227 -0.232 -0.023 -0.52 -0.052 -0.593 -0.153 -0.071 -0.098 -0.011 -0.379 0.038 -0.604 0.064 -0.294 0.13 -0.598 0.041 -0.87 -0.085 -0.262 -0.312 -0.463 -0.532 -0.658 -0.187 -0.166 -0.398 -0.353 -0.398 -0.488s0.212 -0.323 0.398 -0.488c0.22 -0.195 0.447 -0.397 0.532 -0.658 0.088 -0.272 0.022 -0.576 -0.041 -0.87 -0.049 -0.226 -0.11 -0.506 -0.038 -0.604 0.074 -0.101 0.362 -0.13 0.593 -0.153 0.298 -0.03 0.606 -0.061 0.835 -0.227 0.226 -0.164 0.349 -0.446 0.468 -0.718 0.094 -0.215 0.211 -0.482 0.334 -0.523a0.12 0.12 0 0 1 0.037 -0.005c0.125 0 0.332 0.12 0.514 0.226 0.263 0.154 0.535 0.312 0.827 0.312s0.563 -0.158 0.827 -0.312c0.182 -0.106 0.388 -0.226 0.514 -0.226a0.12 0.12 0 0 1 0.038 0.005c0.122 0.04 0.239 0.307 0.334 0.523 0.119 0.272 0.242 0.554 0.468 0.718 0.229 0.166 0.537 0.197 0.835 0.227 0.232 0.023 0.52 0.052 0.593 0.153 0.071 0.098 0.011 0.379 -0.038 0.604 -0.064 0.294 -0.13 0.598 -0.041 0.87 0.085 0.262 0.312 0.463 0.532 0.658 0.187 0.166 0.398 0.353 0.398 0.488s-0.212 0.323 -0.398 0.488c-0.22 0.195 -0.447 0.397 -0.532 0.658"/><path d="M7.032 1.622c-1.757 0 -3.188 1.43 -3.188 3.188s1.43 3.188 3.188 3.188 3.188 -1.43 3.188 -3.188 -1.43 -3.188 -3.188 -3.188m0 5.813c-1.448 0 -2.625 -1.178 -2.625 -2.625s1.178 -2.625 2.625 -2.625 2.625 1.178 2.625 2.625 -1.178 2.625 -2.625 2.625"/><path d="M7.032 2.594a2.217 2.217 0 0 0 -2.215 2.215 0.281 0.281 0 0 0 0.563 0 1.654 1.654 0 0 1 1.652 -1.652 0.281 0.281 0 0 0 0 -0.563"/></g></g></svg>
            </span>`;
  }
  return "";
}

function displayData(data) {
  var container = document.getElementById("data-container");
  container.innerHTML = "";
  if (data.length > 0) {
    // Sort data A-Z by store_name (heading-title)
    data = data.slice().sort((a, b) => {
      const aTop = a.is_top_retailer === true || a.is_top_retailer === "true";
      const bTop = b.is_top_retailer === true || b.is_top_retailer === "true";

      // Top retailers always first
      if (aTop && !bTop) return -1;
      if (!aTop && bTop) return 1;

      // A-Z within same group
      var nameA = (a.store_name || "").toLowerCase();
      var nameB = (b.store_name || "").toLowerCase();
      return nameA.localeCompare(nameB);
    });

    var addressListHtml = '<div class="address-list__items grid">';

    // Array to hold promises
    var geocodePromises = data.map((addressString, index) => {
      let address = constructAddress(
        addressString["address"],
        addressString["city"],
        addressString["state"],
        addressString["zip_code"]
      );

      // Return the geocode promise
      return geocodeAddress(
        address,
        addressString["store_name"],
        websiteURL,
        addressString["city"],
        addressString["latitude"],
        addressString["longitude"]
      ).then((coords) => {
        // Build HTML for each addres
        var city = addressString["city"];
        if (city in cityCount) {
          cityCount[city]++;
        } else {
          cityCount[city] = 1;
        }
        // <div class="divDescription"><a target="_blank" href="https://www.google.com/maps/place/${
        //                    coords.lat
        //                  },${coords.lng}">${address}</a></div>
        return {
          html: `
            <div class="address-line" id="address-line-${index}">
              <div class="address-item">
                <div class="badge_icons">
                 ${getTopRetailerBadge(addressString["is_top_retailer"])}
                 ${getHeighlight(addressString["tags"], index)}
                </div>
                <div class="description">
                  <h3 class="heading-title">${addressString["store_name"]}</h3>
                  <h2 onclick="toggleDescription(${index})" class="description-text-${index}">DESCRIPTION ▼</h2>
                  <div id="desc-content-${index}" class="desc-content">
                    <p>${addressString["descriptions"]}</p>
                  </div>
                  <div class="divDescription"><a target="_blank" href="https://www.google.com/maps/place/${address}">${address}</a></div>
                  <p class="phone">${getPhoneNumber(
                    addressString["store_telephone"],
                    addressString["telephone"]
                  )}</p>
                  <div class="link-container">
                  <a target="_blank" href="${getTheURL(
                    addressString["website"]
                  )}" class="store-link" title="${websiteURL}">${websiteURL}</a>
                  </div>
                </div>
              </div>
            </div>`,
          index,
        };
      });
    });

    //PostAPI For the coordinates
    //shareCoordinatesWithAPI();

    // Use Promise.all to wait for all geocode requests to complete
    Promise.all(geocodePromises)
      .then((results) => {
        // Combine all HTML results into one string
        addressListHtml += results.map((result) => result.html).join("");
        addressListHtml += "</div>";
        container.innerHTML = addressListHtml;
console.log("data", data)
        setMapCenterToMostFrequentCity(data);
      })
      .catch((error) => {
        console.error("Error in geocoding addresses:", error);
        container.innerHTML =
          "<H2 class='noDataFound'>Error retrieving address data.</H2>";
      });
  } else {
    container.innerHTML = "<H2 class='noDataFound'>No addresses found.</H2>";
  }
}

function generateGoogleMapsLink(address) {
  var encodedAddress = encodeURIComponent(address);
  var googleMapsUrl = "https://www.google.com/maps/place/" + encodedAddress;

  return googleMapsUrl;
}

function getTheURL(link) {
  if (link.startsWith("https://")) {
    websiteURL = link.replace("https://", "");
    httpsWebSiteLink = link;
    return httpsWebSiteLink;
  } else if (link.startsWith("http://")) {
    websiteURL = link.replace("http://", "");
    httpsWebSiteLink = link;
    return httpsWebSiteLink;
  } else {
    websiteURL = link;
    httpsWebSiteLink = "https://" + link;
    return httpsWebSiteLink;
  }
}

function getHeighlight(tags, index) {
  // Split and trim tags, converting them to lowercase for case-insensitive comparison
  var splittags = tags.split(",").map((tag) => tag.trim().toLowerCase());
  var htmlText = '<span class="icon"></span>'; // Default HTML content
  // console.log("splittags", splittags.length)
  if (splittags.length > 1) {
    console.log("splittags.length", splittags.length);
  }
  if (
    splittags.some((tag) => tag !== "online") &&
    splittags.some((tag) => tag !== "highlight")
  ) {
    htmlText = '<span class="icon no-online-highlight"></span>';
  }
  if (splittags.some((tag) => tag === "highlight")) {
    htmlText = '<span class="highlight"></span>';
  }
  if (splittags.some((tag) => tag === "online")) {
    htmlText =
      '<span class="icon online-tag"><img src="https://cdn.shopify.com/s/files/1/0575/0643/1039/files/highlight-iicon.jpg?v=1721508089" alt="Highlight Icon"></span>';
  }
  if (
    splittags.some((tag) => tag === "online") &&
    splittags.some((tag) => tag === "highlight")
  ) {
    htmlText =
      '<span class="icon online-highlight"><img src="https://cdn.shopify.com/s/files/1/0575/0643/1039/files/highlight-iicon.jpg?v=1721508089" alt="Highlight Icon"></span>';
  }
  return htmlText;
}

function constructAddress(address, city, state, zip_code) {
  // Initialize an array to hold parts of the address
  var addressParts = [];
  if (address) {
    addressParts.push(address);
  }
  if (city) {
    addressParts.push(city);
  }
  if (state) {
    addressParts.push(state);
  }

  var address = addressParts.join(", ");
  if (zip_code) {
    // addressParts.push(zip_code);
    address = address + " " + zip_code;
  }
  return address;
}

function getMaxUsedCity(addresses) {
  // Use an object to store city counts
  let cityCount = addresses.reduce((acc, address) => {
    let city = address.city;
    acc[city] = (acc[city] || 0) + 1;
    return acc;
  }, {});

  // Find the city with the maximum count
  let maxCity = "";
  let maxCount = 0;

  for (let city in cityCount) {
    if (cityCount[city] > maxCount) {
      maxCount = cityCount[city];
      maxCity = city;
    }
  }

  return maxCity;
}

$("#categorie-filter").on("change", applyFilters);
$("#address-filter").on("change", applyFilters);
$("#store-filter").on("change", applyFilters);

function applyFilters() {
  var selectedLocation = $("#address-filter").val();
  var selectedCategory = $("#categorie-filter").val();
  var selectedStore = $("#store-filter").val();

  // Filter the addressObjList based on selectedLocation and selectedCategory
  var filterData = addressObjList.filter((data) => {
    // Check if both filters are "All" or match the data
    var matchLocation =
      selectedLocation === null ||
      selectedLocation === "All" ||
      (data.location &&
        data.location.trim().toLowerCase() ===
          selectedLocation.trim().toLowerCase());

    var matchCategory;
    if (selectedCategory?.toLowerCase() === "online") {
      // Check if 'tags' contain 'online'
      matchCategory =
        data.tags &&
        data.tags
          .split(",")
          .map((tag) => tag.trim().toLowerCase())
          .some((tag) => tag === "online");
    } else {
      // Regular category matching
      matchCategory =
        selectedCategory === null ||
        selectedCategory === "All" ||
        (data.category &&
          typeof data.category === "string" &&
          data.category.trim().toLowerCase() ===
            selectedCategory.trim().toLowerCase());
    }
    var matchStore =
      selectedStore === null ||
      selectedStore === "All" ||
      (data.store_name &&
        data.store_name.trim().toLowerCase() ===
          selectedStore.trim().toLowerCase());

    return matchLocation && matchCategory && matchStore;
  });

  displayData(filterData);
  updateMapMarkers(filterData);
  if (filterData.length > 0) {
    setMapCenterToMostFrequentCity(filterData);
  }
}

function toggleDescription(id) {
  var content = document.getElementById("desc-content-" + id);
  var h2 = document.querySelector(".description-text-" + id);
  if (content.style.display === "block") {
    content.style.display = "none";
    h2.innerHTML = "DESCRIPTION ▼";
  } else {
    content.style.display = "block";
    h2.innerHTML = "DESCRIPTION ▲";
  }
}

function getPhoneNumber(telephone, number) {
  if (!telephone) {
    return number;
  } else {
    return telephone;
  }
}

// MAP Code
function initMap() {
  // The location of your map center (example: New York)
  var center = { lat: 40.7128, lng: -74.006 };

  // The map, centered at your location
  map = new google.maps.Map(document.getElementById("map"), {
    zoom: 12, // Adjust zoom level (1 = World view, 20 = street level)
    center: center,
  });
}

function geocodeAddress(
  addressLine,
  storeName,
  website,
  city,
  exi_latitued,
  exi_longitued
) {
  return new Promise((resolve, reject) => {
    //var geocoder = new google.maps.Geocoder();

    let coords = {
      lat: parseFloat(exi_latitued),
      lng: parseFloat(exi_longitued),
    };
    //var location = coords;

    try{
      // Create a marker and add it to the map
    var marker = new google.maps.Marker({
      map: map,
      position: coords,
    });

    // Create an info window with details
    // <a href="https://www.google.com/maps/place/${location.lat()},${location.lng()}" target="_blank">Get directions</a>

    var infoWindow = new google.maps.InfoWindow({
      content: `<div class="div-info-address">
                      <strong>${storeName}</strong><br>
                      ${addressLine}<br>
                      <div class="div-direction">
                        <a href="https://www.google.com/maps/place/${addressLine}" target="_blank">Get directions</a>
                      </div>
                    </div>`,
    });

    marker.addListener("click", function () {
      infoWindow_old.close();
      infoWindow.open(map, marker);
      infoWindow_old = infoWindow;
      //window.open(website, "_blank");
    });
    // Add marker to the markers array
    markers.push(marker);

    }
    catch{
      console.log("Can't find the Address",exi_latitued,exi_longitued)
    }
    // Resolve the promise with the coordinates
    resolve({ exi_longitued, exi_longitued });
  });
}
function updateMapMarkers(filteredData) {
  console.log("filteredData", filteredData)
  // Clear existing markers
  markers.forEach((marker) => marker.setMap(null));
  markers = [];

  // Add new markers based on filtered data
  filteredData.forEach((addressString) => {
    let address = constructAddress(
      addressString["address"],
      addressString["city"],
      addressString["state"],
      addressString["zip_code"]
    );
    //geocodeAddress(address, addressString["store_name"]);
    geocodeAddress(
      address,
      addressString["store_name"],
      getTheURL(addressString["website"]),
      addressString["city"],
      addressString["latitude"],
      addressString["longitude"]
    );
  });
}

function setMapCenterToMostFrequentCity(data) {
  var cityCount = {};
  var maxCity = "";
  var maxCount = 0;

  // Count occurrences of each city in the filtered data
  data.forEach((item) => {
    var city = item.city;

    if (city in cityCount) {
      cityCount[city]++;
    } else {
      cityCount[city] = 1;
    }
  });

  // Determine the city with the maximum count
  for (var city in cityCount) {
    if (cityCount[city] > maxCount) {
      maxCount = cityCount[city];
      maxCity = city;
    }
  }

  var mostUsedCity = data.filter((data) => data.city === maxCity);

  // Ensure that the mostUsedCity has data
  if (mostUsedCity.length > 0) {
    var add = constructAddress(
      mostUsedCity[0]["address"],
      mostUsedCity[0]["city"],
      mostUsedCity[0]["state"],
      mostUsedCity[0]["zip_code"]
    );

    var latitude = Number(mostUsedCity[0]["latitude"]);
    var longitude = Number(mostUsedCity[0]["longitude"]);

    // Check for valid latitude and longitude
    if (!isNaN(latitude) && !isNaN(longitude) && 
        latitude !== 0 && longitude !== 0) {
      var code = { lat: latitude, lng: longitude };
      var geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: add }, function (results, status) {
        if (status === "OK") {
          map.setCenter(code);
        } else {
          console.error('Geocode was not successful for the following reason: ' + status);
        }
      });
    } else {
      console.error('Invalid latitude or longitude:', latitude, longitude);
    }
  } else {
    console.error('No data found for the most used city.');
  }
}

